<template>
    <div class="fullscreen-div">
<!--        <div>-->
            <img  src="~@public/img/hotApply/img_zfb.jpg">
<!--        </div>-->
    </div>
</template>

<script>

    import {Button, Toast, Dialog} from 'vant';
    import {memberApi} from '@/api/member';
    import {Source} from "@/utils/source";
    import { setToken, removeToken } from "@/utils/auth"

    export default {
        name: "HuberMap",
        components: {
            [Button.name]: Button,
            [Toast.name]: Toast
        },
        data() {
            return {
                userGuid: this.$route.params.userUid, // 用户的guid
                queryUrl: this.$route.params.queryUrl, // 事项跳链接的guid
                guideInfo: {}, // 存放指南信息
                legalBasisShow: true, // 根据'法律依据'有没有值，判断是否展示
                applicationConditionsShow: true, // 根据'申请条件'有没有值，判断是否展示
                applicationMaterialsShow: true, // 根据'申报材料'有没有值，判断是否展示
                chargesShow: true, // 根据'收费标准'有没有值，判断是否展示
                commitmentPeriodShow: true,  // 根据'承诺期限'的返回值，判断展示内容
                guidePicShow: true    //判断是否展示流程图
            }
        },
        mounted() {
            console.log(this.$route.params)
            this.getGuideUserInfo()
        },
        methods: {
            /**
             * 支付宝单点登录
             */
            async getGuideUserInfo() {
                // Toast.loading({
                //     duration: 0,       // 持续展示 toast
                //     forbidClick: true, // 禁用背景点击
                //     loadingType: 'spinner',
                //     message: '登录中...'
                // })
                try {
                    const uuid = this.userGuid
                    // let res = await this.$httpUtils.postGatewayUtils(memberApi.szfFormLogin, data)
                    const res = await this.$httpUtils.getGatewayUtils(`/member/hubei/public/automatToken/${uuid}`)
                    console.log(res)
                    if (res.data.access_token) {
                        const access_token = res.data.access_token
                        const refresh_token = res.data.refresh_token
                        setToken('access_token', access_token)
                        setToken('refresh_token', refresh_token)
                        const info = await this.$httpUtils.getGatewayUtils(memberApi.getUserInfo)
                        const userInfo = info.data.data
                        this.$cookie.setUser(userInfo)
                        this.$store.commit('LOGIN_SWITCH', true)
                        this.logger.visit('901','1')
                        this.$router.push("/"+this.queryUrl);
                        // Toast.success('登录成功')
                    }  else {
                        Toast.fail('自动登陆失败，请稍后重试')
                    }
                } catch (e) {
                    Toast.fail('服务器运行失败，请稍后再试。')
                    console.log(error)
                }

            },
        }
    }
</script>


<style scoped lang="less">
    body, #app{
        height: 100%;
        width: 100%!important;
    }
     .fullscreen-div {
        height: 100%;
        width: 100%;
         img{
             height: 100%;
             width: 100%;
         }
    }
</style>
